var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getApiClient } from "../../services/AxiosClients";
import FetchService from "./Shared/FetchService";
export default class IntentService {
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/intents/search/findByNameLike", {
                params: { search },
            });
            return response.data._embedded.intents;
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiClient = getApiClient();
            const response = yield apiClient.get("/intents/search/findByIdIn", {
                params: { ids: ids.join(",") },
            });
            return response.data._embedded.intents;
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getPagedResponse("/aviso/Intent/search", {
                query: search.query,
                active: search.active,
                ids: search.ids,
                codes: search.codes,
                intentIds: search.intentIds,
                srcSystemIds: search.srcSystemIds,
                names: search.names,
                max: options.max,
                offset: options.offset,
                sort: options.sort,
                order: options.order,
            });
        });
    }
}
